<template>
    <div>
        <div class="row">
            <div class="card">
                <div class="card-header">
                    <div class="row">

                        <div class="col-xs-3 col-md-1">
                            <center>
                                <i style="font-size: 300%; color: grey" class="fa fa-file"></i>
                            </center>
                            <br>
                        </div>
                        <div class="col-xs-9 col-md-11">
                            <p class="title-card">
                                <strong style="color: grey">Gestión de autorizaciones</strong>
                                <br>
                                <small>Administra la información de las ordenes y autorizaciones de AVANZA.</small>
                            </p>
                        </div>


                    </div>

                </div>
                <div class="card-content">
                    <div class="row">
                        <div class="col-md-7">
                            <label for="">Código:</label>
                            <input type="text" v-model="codigo" placeholder="Ingrese el código de la autorización"
                                class="form-control" />
                        </div>
                        <div class="col-md-2">
                            <label for="" style="color:white;">dd</label> <br>
                            <button class="btn btn-success btn-fill" style="border-radius:5px;"
                                @click="buscarAutorizacion()"> <i class="fa fa-search"></i> Buscar</button>
                        </div>
                    </div> <br>
                    <div class="row" v-if="numeroAutorizacion != 0">
                        <div class="col-md-12">

                            <div class="card">
                                <div class="card-header">
                                    <h4 v-if="tipo == 1"> Autorización N° {{ numeroAutorizacion }}</h4>
                                    <h4 v-else> Orden médica N° {{ numeroAutorizacion }}</h4>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label for="">Paciente:</label>
                                        <input type="text" class="form-control" readonly v-model="pacienteAutorizacion">
                                    </div>
                                    <div class="col-md-6">
                                        <label for="">Entidad:</label>
                                        <input type="text" class="form-control" readonly v-model="entidadAutorizacion">
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label for="">Fecha Expedición:</label>
                                        <input type="text" class="form-control" readonly v-model="fechaAutorizacion">
                                    </div>
                                    <div class="col-md-6">
                                        <label for="">Fecha Vencimiento:</label>
                                        <input type="date" class="form-control" v-model="fechaVencimientoAutorizacion">
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6" v-if="tipo == 1">
                                        <label for="">Saldo en bolsa:</label>
                                        <input type="text" class="form-control" v-model="bolsa">
                                    </div>

                                    <div class="col-md-6"> <br>
                                        <button v-if="tipo == 1" @click="ajustar()" class="btn btn-success">Ajustar
                                            autorización</button>
                                        <button v-if="tipo == 0" @click="ajustar()" class="btn btn-success">Ajustar
                                            orden</button>
                                        <button v-if="tipo == 1" @click="cancelarOrden()" class="btn btn-primary">Cancelar
                                            autorización</button>
                                        <button v-if="tipo == 0" @click="cancelarOrden()" class="btn btn-primary">Cancelar
                                            orden</button>
                                        <button class="btn btn-danger" @click="numeroAutorizacion = 0">Cancelar</button>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div></template>



<script>
import axios from "axios";

export default {
    data: () => ({
        codigo: '',
        ip: 'https://avanti-erp.com/',
        numeroAutorizacion: 0,
        pacienteAutorizacion: '',
        entidadAutorizacion: '',
        fechaAutorizacion: '',
        fechaVencimientoAutorizacion: '',
        id: 0,
        tipo: 0,
        bolsa: 0
    }),
    methods: {
        buscarAutorizacion: function () {
            const BASE_URL = `${this.ip}api/buscarAutorizacion/${this.codigo}`;
            axios.get(BASE_URL).then(res => {
                if (res.data.mensaje == 'Cargada') {
                    console.log('data', res.data.data)
                    this.numeroAutorizacion = res.data.data[0].OrdCod;
                    this.pacienteAutorizacion = res.data.data[0].PacApe1 + ' ' + res.data.data[0].PacNom1;
                    this.entidadAutorizacion = res.data.data[0].EpsNom;
                    this.fechaAutorizacion = res.data.data[0].OrdFec;
                    this.fechaVencimientoAutorizacion = res.data.data[0].OrdVen;
                    this.bolsa = res.data.data[0].OrdBol;
                    this.id = res.data.data[0].OrdIde;
                    this.tipo = res.data.data[0].OrdFor;
                } else {
                    alert('No se encontró una Autorización con este código')
                }
            })
        },
        cancelarOrden: function () {
            const BASE_URL = `${this.ip}api/cancelarOrdenMedica/${this.numeroAutorizacion}/${this.id}`;
            axios.put(BASE_URL).then(res => {
                if (res.data.mensaje == 'No se puede cancelar') {
                    alert('Esta orden no se puede cancelar porque tiene autorizaciones cargadas')
                } else if (res.data.mensaje == 'Cancelado con éxito') {
                    alert('Cancelada con éxito')
                    this.numeroAutorizacion = 0
                }
            }).catch(err => {
                console.log(err)
            })
            // const BASE_URL = `${this.ip}api/cancelarOrden/${this.codigo}`;
        },

        ajustar: function () {
            const BASE_URL = `${this.ip}api/ajustar`;
            axios.post(BASE_URL, {

                bolsa: this.bolsa,
                vencimiento: this.fechaVencimientoAutorizacion,
                id: this.id

            }).then(res => {
                if (res.data.mensaje == 'Ajustado con éxito') {
                    alert('Ajustado con éxito')
                    this.buscarAutorizacion();
                } else {
                    alert('Error al ajustar')
                }

            }).catch(err => {
                console.log(err)
            })
        }
    },
    mounted() {

    }
}
</script>
<style lang="css" scoped>
.card-header {
    padding-bottom: 10px !important;
    background-color: #f3f2ee;
    border-radius: 15px !important;
}

.card {
    box-shadow: 0 0 0 0;
    border-radius: 15px;
    padding: 2%;
}

.card-chart {
    box-shadow: 0 0 0 0;
    border-radius: 15px;
    /* padding: 4%; */
    margin: 2px;
    background-color: white !important;
}</style>


// WEBPACK FOOTER //
// src/components/ADashboard/gestionOrdenes.vue